export const POST_API = async (url, bodyData, access_token) => {
    return await fetch(url, {
      method: "POST",
      headers: {
        "Content-type": "application/json",
        "Authorization": `Bearer ${access_token}`,
      },
      body: JSON.stringify(bodyData),
      
    })
      .then((res) => res.json())
      .then((res) => {
        return res;
      });
  };
  
  